import React from 'react';
import DebouncedTextInput from '../../components/debounced-text-input';
import { SearchIcon } from '@patternfly/react-icons';
import './CustomizationSearchBar.css';

interface CustomizationSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

const CustomizationSearchBar: React.FC<CustomizationSearchBarProps> = ({ value, onChange }) => (
  <div className="customization-search-bar-outer">
    <div className="customization-search-bar-inner">
      <span className="customization-search-icon">
        <SearchIcon />
      </span>
      <DebouncedTextInput
        fieldId="customization-tree-search"
        placeholder="Search model..."
        defaultValue={value}
        onDebouncedChange={onChange}
        debounceTimeMs={75}
        className="customization-search-input"
        type="search"
        testId="model-filter-search-input"
      />
    </div>
  </div>
);

export default CustomizationSearchBar; 